import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"



// Define emits

export default /*#__PURE__*/_defineComponent({
  __name: 'CreatePayments',
  emits: ['newPayment'],
  setup(__props, { emit: emits }) {




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("h3", null, "create payments"))
}
}

})